export default __webpack_public_path__ + "static/media/groovehq.22ece0c8.svg";